"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSuburbInput = instanceOfSuburbInput;
exports.SuburbInputFromJSON = SuburbInputFromJSON;
exports.SuburbInputFromJSONTyped = SuburbInputFromJSONTyped;
exports.SuburbInputToJSON = SuburbInputToJSON;
exports.SuburbInputToJSONTyped = SuburbInputToJSONTyped;
/**
 * Check if a given object implements the SuburbInput interface.
 */
function instanceOfSuburbInput(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    return true;
}
function SuburbInputFromJSON(json) {
    return SuburbInputFromJSONTyped(json, false);
}
function SuburbInputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
    };
}
function SuburbInputToJSON(json) {
    return SuburbInputToJSONTyped(json, false);
}
function SuburbInputToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
    };
}
